import React from 'react';
import Banner from "../components/Banner.js"; 
import CoinsTable from '../components/CoinsTable.js';
const Home = () => {
  return (
    <>
      <Banner />
      <CoinsTable />

    </>
  );
};

export default Home;
